import { useContext } from 'react'

import swal from 'sweetalert2'

import {
  faArchive, faDatabase, faFileExport, faStore,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, Tools } from '@domain-group/suit-theme'

import type { UseBrandPayload } from '@hooks/useBrand'

import PageContext from '@contexts/pageContext'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { BrandModel } from '@models/types'

interface ConfirmArchiveProps {
  activeText: string,
  brand: BrandModel,
  updateBrand: (payload: object) => Promise<object>,
  updateFn: (payload: object) => Promise<object>,
}

const confirmArchive = (params: ConfirmArchiveProps) => {
  const {
    activeText,
    brand: {
      id,
      hidden,
    },
    updateBrand,
    updateFn,
  } = params

  const toggleHiddenPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: { id, hidden: !hidden },
    toastText: `Brand Marked as ${activeText}`,
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: `Yes, mark as ${activeText.toLowerCase()}.`,
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: `Mark Brand as ${activeText}?`,
  })
    .then(({ value }) => {
      if (value){
        updateBrand(toggleHiddenPayload)
      }
    })
}

interface BrandProps {
  brandPayload: UseBrandPayload,
  brandSettingsFlipperEnabled?: boolean,
  brandSettingsTab?: boolean,
}

const Brand = (props: BrandProps) => {
  const {
    brandPayload, brandSettingsFlipperEnabled, brandSettingsTab,
  } = props
  const {
    brand,
    callbacks: {
      editBrandSSO,
      editBrandSettings,
      exportBrand: exportFn,
      updateBrand: updateFn,
    },
    loading,
  } = brandPayload

  const { hidden } = brand
  const activeText = hidden ? 'Active' : 'Inactive'

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      exportBrand,
      updateBrand,
    },
  } = pageContext

  const exportBrandPayload = {
    callbacks: {
      action: exportFn,
    },
    toastText: 'Export Brand Queued',
  }

  return (
    <Tools>
      {!brandSettingsTab && !brandSettingsFlipperEnabled && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faStore} />}
          loading={loading}
          onClick={() => editBrandSettings()}
          size="medium"
        >
          Brand Settings
        </Button>
      )}

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faDatabase} />}
          loading={loading}
          //@ts-expect-error
          marginTop="medium"
          onClick={() => editBrandSSO()}
          size="medium"
        >
          SSO API
        </Button>

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faArchive} />}
          loading={loading}
          //@ts-expect-error
          marginTop="medium"
          onClick={() => confirmArchive({
            brand, updateBrand, updateFn, activeText,
          })}
          size="medium"
        >
          { `Mark ${activeText}`}
        </Button>

        {!brandSettingsTab && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faFileExport} />}
            loading={loading}
            //@ts-expect-error
            marginTop="medium"
            onClick={() => exportBrand(exportBrandPayload)}
            size="medium"
          >
            Export Brand
          </Button>
        )}
      </ScopedConditionalContent>
    </Tools>
  )
}

export default Brand
